export const STRIPE_CUSTOMER_IDS_CLAIMS_KEY = 'stripe_customer_ids';
export const STRIPE_WEBHOOK_ACCOUNT = 'stripe-account';

export const UNIDENTIFIED_USER_ID = 'unidentified-user';

export const BUNNY_API_BASE = 'https://video.bunnycdn.com/';

export const FIREBASE_VERIFIED_AT_CLAIMS_KEY = 'firebase_verified_at';

export * from './titanFeatureFlagsConfig';
